import TollIcon from '@mui/icons-material/Toll';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

export const MissionSessionIcon = () => <TollIcon />;
export const MissionSessionParticipantIcon = () => <TaskAltIcon />;
